module.exports = __webpack_public_path__ + "static/media/stemModifiedTendril.7b43f9a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stemModifiedTendril.png
// module id = 311
// module chunks = 0